import { useEffect, useState } from 'react';
import React from 'react';
import styles from './../../admin/styles.module.scss'
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '@store/types';

interface NavItem {
    id: string;
    title: string;
    iconRef: string;
    url: string;
}

interface DynamicLeftNavProps {
    selected_id: string;
    type: 'admin' | 'others';
}

const DynamicLeftNav: React.FC<DynamicLeftNavProps> = ({ selected_id, type }) => {
    const [navList, setNavList] = useState<NavItem[]>([]);
    const { envVariables: Env } = useSelector((store: RootState) => store.AccountReducer);

    useEffect(() => {
        const nav: NavItem[] = [];

        if (type === 'admin') {
            nav.push({
                id: 'user',
                title: 'User Management',
                iconRef: '/icons/user-manage.svg',
                url: '/admin/user-management',
            });

            if (Env?.ENABLE_GROUP_MANAGEMENT) {
                nav.push({
                    id: 'group',
                    title: 'Group Management',
                    iconRef: '/icons/user-manage.svg',
                    url: '/admin/group-management',
                });
            }
        } else if (type === 'others') {
           if(Env?.REACT_SHOW_ASSET_HIERARCHY){ nav.push(
            //     {
            //     id: 'asset',
            //     title: 'Asset Hierarchy',
            //     iconRef: '/icons/asset-hierarchy.svg',
            //     url: '/others/asset-hierarchy',
            // },
             {  // for demo
                id: 'project-asset',      
                iconRef: '/icons/asset-hierarchy.svg',
                title: 'Projects',
                url: '/others/project-asset-hierarchy'
            });}

            if (!Env?.REACT_APP_DISABLE_GIT_INTEGRATION) {
                nav.push({
                    id: 'git',
                    title: 'Git Management',
                    iconRef: '/icons/git-integration.svg',
                    url: '/others/git-integration-settings',
                });
            }

            if (Env?.REACT_SHOW_PI_REQUESTS_TABLE) {
                nav.push({
                    id: 'nifi',
                    title: 'Edge Management',
                    iconRef: '/icons/nifi.svg',
                    url: '/others/nifi-management',
                });
            }
        }

        setNavList(nav);
    }, [Env, type]);

    const header = type === 'admin' ? 'Administrator' : 'Others';

    return (
        <div className={classNames(styles["treeview__container"])}>
            <h2 className={styles["header"]}>{header}</h2>
            <ul>
                {navList.map((tab) => (
                    <li
                        key={tab.id}
                        className={classNames({
                            [styles["selected"]]: tab.id === selected_id,
                        })}
                    >
                        <Link to={tab.url}>
                            <img src={tab.iconRef} alt={`${tab.title} icon`} />
                            <span>{tab.title}</span>
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default DynamicLeftNav;
